var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7557 21.4757C36.7306 23.4259 38.5197 24.5142 39.8673 25.1612C41.252 25.8252 41.717 26.2509 41.7117 26.8445C41.7012 27.7532 40.6071 28.1542 39.5833 28.1698C37.7969 28.1971 36.7583 27.6946 35.9326 27.3145L35.2892 30.2813C36.1176 30.6576 37.6515 30.9857 39.2424 31C42.9762 31 45.4191 29.1839 45.4324 26.3681C45.4469 22.7946 40.4156 22.5966 40.4499 20.9993C40.4618 20.515 40.9309 19.9981 41.9588 19.8667C42.4674 19.8003 43.8719 19.7495 45.4641 20.472L46.089 17.6015C45.2328 17.2943 44.1322 17 42.7621 17C39.2476 17 36.7756 18.8408 36.7557 21.4757ZM52.0941 17.2473C51.4123 17.2473 50.8376 17.6393 50.5813 18.2407L45.2474 30.7891H48.9786L49.7211 28.7673H54.2807L54.7114 30.7891H58L55.1302 17.2473H52.0941ZM52.6159 20.9055L53.6927 25.9905H50.7437L52.6159 20.9055ZM32.2318 17.2473L29.2908 30.7891H32.8462L35.7859 17.2473H32.2318ZM26.972 17.2473L23.2711 26.4643L21.7741 18.6273C21.5985 17.7525 20.9048 17.2473 20.1345 17.2473H14.0846L14 17.6406C15.242 17.9061 16.6531 18.3344 17.5079 18.7927C18.0311 19.0725 18.1804 19.3173 18.3522 19.9825L21.1875 30.7891H24.9452L30.7058 17.2473H26.972Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.3ee33a9dce771ed6ac16e1d2e1ffd624.svg";
export { ForwardRef as ReactComponent };